import {useHistory} from 'react-router';
import {useEffect} from 'react';
import {useMutation} from '@apollo/client';
import {UPDATE_STATUS_OF_UNREAD_ESTIMATE} from '../../graphql/mutations/common.mutation';

import './download.style.css';

export default function Download() {
  const history: any = useHistory();

  const historySearch = history?.location?.search;
  const urlParams = new URLSearchParams(historySearch);

  const [doc, id] = [urlParams.get('url'), urlParams.get('id')];

  if (!doc || !id) {
    history.push('/');
  }

  const [updateStatus] = useMutation(UPDATE_STATUS_OF_UNREAD_ESTIMATE);

  useEffect(() => {
    if (!id || !doc) return;

    const fileUrl = `${process.env.REACT_APP_REST_API_HOST}/api/stream-image?url=${doc}`;

    const link = document.createElement('a');
    link.href = fileUrl;
    // link.setAttribute('download', fileName); // Set the file name
    document.body.appendChild(link);
    link.setAttribute('target', '_blank');
    link.click();

    // Update the status of the unread estimate
    updateStatus({variables: {id: +id}});

    document.body.removeChild(link);
  }, []);

  return (
    <div className='download-container'>
      <p>
        Il file è stato scaricato. Se non si apre automaticamente, controlla la cartella dei
        download del tuo browser.
      </p>
    </div>
  );
}
